<div class="wrapper cm-details-tab visual-inspections" *ngIf="vehicleModel$ | async as currentVehicle">
  <div class="row equal">
    <div class="col-xs-6 mg-col">
      <oc-vehicle-schematic [vehicleObject]="currentVehicle" [maxWidth]="this.ocVehicleSchematicConfig.maxWidth"
          [maxHeight]="this.ocVehicleSchematicConfig.maxHeight" positionsHigh="2" positionsWide="5"
          [topAxle]="this.ocVehicleSchematicConfig.topAxle" [leftPos]="this.ocVehicleSchematicConfig.leftPos"
          [showChains]="false" [showRims]="false" [showPositionLabels]="true" redraw="vm.svgReset"
          [highlightSelected]="true"
          positionView="fitted" [useReadingSequence]="true" [includeFitments]="false" [disabledSegments]="false"
          [buildCSS]="vehicleFitmentData" [(selectedComponent)]="selectedComponent"
          (tyreSelected)="tyreSelected($event)">
      </oc-vehicle-schematic>
    </div>
    <div class="col-xs-6 mg-col block-visual-inspection" id="cmVisualInspectionsetails">
      <div class="row d-flex" *ngIf="currentVehicle.latestReading">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{"UI.Resource.Common.Vehicle"|xlat}}:</label>
        </div>
      <div class="col-xs-6 mg-col">
        <a (click)="showVehicle()">{{vehicle.serialNo}}</a></div>
      </div>
      <div role="row d-flex">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{"equipment.equipmentTypeTyre"|xlat}}:</label>
        </div>
        <div class="col-xs-6 mg-col" *ngIf="selectedComponent?.serialNumber">
          <a (click)="showSelectedTyre()">{{ selectedComponent?.serialNumber }}</a>
        </div>
        <div class="col-xs-6 mg-col" *ngIf="!selectedComponent?.serialNumber">-</div>
      </div>
      <div class="row d-flex" *ngIf="currentVehicle.latestReading">
          <div class="col-xs-6 mg-col">
            <label class="pull-right">{{"conditionmonitoring.TotalVisualInspections"|xlat}}:</label>
          </div>
          <div class="col-xs-6 mg-col">{{viCount(false)}}</div>
        </div>
      <div class="row d-flex" *ngIf="currentVehicle.latestReading">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{"conditionmonitoring.ActiveVisualInspections"|xlat}}:</label>
        </div>
        <div class="col-xs-6 mg-col">{{viCount(true)}}</div>
      </div>
      <div class="row d-flex">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{"conditionmonitoring.LastVisualInspection" | xlat}}:</label>
        </div>
        <div class="col-xs-6 mg-col">
          <span *ngIf="(latestVisualInspection$ | async) as lastVI; else no_lastInspectionDate">{{ lastVI.lastVisualInspectionDate | date:'dd-MM-yyyy' }}</span>
          <ng-template #no_lastInspectionDate>-</ng-template>
        </div>
      </div>
      <div class="row d-flex">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{"conditionmonitoring.last_visual_inspection_by" | xlat}}:</label>
        </div>
        <div class="col-xs-6 mg-col">
          <span *ngIf="(latestVisualInspection$ | async) as lastVI; else no_lastInspectionBy">{{ lastVI.lastVisualInspectionBy }}</span>
          <ng-template #no_lastInspectionBy>-</ng-template>
        </div>
      </div>
      <div class="row d-flex">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{"visualInspectionAction.next_action_due_date" | xlat}}:</label>
        </div>
          <div class="col-xs-6 mg-col">
            <span *ngIf="(earliestDueVisualInspection$ | async)?.nextActionDueDate as earliestDue; else no_actionDueDate">{{ earliestDue | date:'dd-MM-yyyy'}}</span>
            <ng-template #no_actionDueDate><span>-</span></ng-template>
          </div>
        </div>
      <div class="row d-flex">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{"conditionmonitoring.next_action_due_status"|xlat}}:</label>
        </div>
        <div class="col-xs-6 mg-col">
          <span
            *ngIf="getVIStatus(earliestDueVisualInspection$ | async) as viStatus; else no_viStatus"
            [ngClass]="{ 'overdue': viStatus === 'conditionmonitoring.vi_overdue' }">{{ viStatus | xlat }}</span>
          <ng-template #no_viStatus><span>-</span></ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- Once a position is selected -->
  <div class="row">
    <div class="col-xs-12 mg-col k-grid cm-overrides">
      <h3><strong>{{"lastVisualInspection.VisualInspectionLog"|xlat}}</strong></h3>
      <app-custom-grid [dataView]="(displayVisualInspections$ | async)" [columns]="columns" [gridConfig]="dataGridConfig"
        (onEditGridItem)="showComponent($event)"></app-custom-grid>
    </div>

  </div> <!-- row -->
</div>